export default "__VITE_ASSET__bb6c3f54__"